export enum DeviceReportStatusEnum {
    RECENT = 'recent', // Green
    DELAYED = 'delayed', // Yellow
    OUTDATED = 'outdated', // Red
    UNAVAILABLE = 'unavailable', // Grey
}
